export enum Theme {
    global = 'global',
    sura = 'sura',
    aquashield = 'aquashield',
    cobelen = 'cobelen'
}
